import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useActionCountData } from '@/hooks/useActionCountData';
import { useNavigate } from 'react-router-dom';
import { LineChart, Line, ResponsiveContainer } from 'recharts';
import { TrendingUp, AlertCircle, Clock } from 'lucide-react';

export function ActionCountWidget() {
  const { totalActive, overdueCount, dueTodayCount, trendData, momentum, loading } = useActionCountData();
  const navigate = useNavigate();
  return null; // Temporarily disable the widget
  if (loading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Action Center</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="animate-pulse">
            <div className="h-16 bg-muted rounded mb-4"></div>
            <div className="h-8 bg-muted rounded mb-2"></div>
            <div className="h-10 bg-muted rounded"></div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="relative overflow-hidden transition-all duration-200 hover:shadow-lg hover:scale-[1.02] group">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg">Action Center</CardTitle>
          <div className="flex gap-1">
            {false && overdueCount > 0 && (
              <Badge variant="destructive" className="text-xs px-2 py-1">
                <AlertCircle className="w-3 h-3 mr-1" />
                {overdueCount >= 20 ? "20+" : overdueCount}
              </Badge>
            )}
            {false && dueTodayCount > 0 && (
              <Badge variant="secondary" className="text-xs px-2 py-1">
                <Clock className="w-3 h-3 mr-1" />
                {dueTodayCount >= 20 ? "20+" : dueTodayCount}
              </Badge>
            )}
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Hero Number */}
        <div className="text-center">
          <div className="text-4xl font-bold text-foreground mb-1 transition-all duration-300 group-hover:text-primary group-hover:scale-105">
            {totalActive >= 20 ? "20+" : totalActive}
          </div>
          <div className="text-sm text-muted-foreground">
            Recent Activity
          </div>
        </div>

        {/* Trend Chart */}
        {trendData.length > 0 && (
          <div className="h-16 w-full">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={trendData}>
                <Line 
                  type="monotone" 
                  dataKey="count" 
                  stroke="hsl(var(--primary))" 
                  strokeWidth={2}
                  dot={false}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        )}

        {/* Momentum Text */}
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>{momentum.todayText}</span>
          <div className="flex items-center gap-1">
            <TrendingUp className="w-3 h-3" />
            <span>{momentum.trendText}</span>
          </div>
        </div>

        {/* CTA Button */}
        <Button 
          onClick={() => navigate('/actions')}
          className="w-full transition-all duration-200 hover:shadow-md"
          size="sm"
        >
          Visit Action Center
        </Button>
      </CardContent>
    </Card>
  );
}